import { Typography } from "@mui/material";
import PropTypes from "prop-types";
import { PrimaryInfoAlert } from "react-common-ui-library";
import { useIntl } from "react-intl";
import { CONTACT_NUMBER } from "../../../Constants/CommonConstants";
import ConfigService from "../../../Services/ConfigService";

const contactNumber = ConfigService(CONTACT_NUMBER);

/**
 * @description Info alert that can be imported in ForgotUsername component.
 * @param {function} contentId id for the content that will be displayed inside the alert.
 * @returns {ReactNode} Render the Primary Alert from component library that accepts contentId as prop.
 */
const ForgotPasswordInfoAlert = ({ contentId, title }) => {
  const intl = useIntl();

  return (
    <PrimaryInfoAlert
      title={intl.formatMessage({ id: title })}
      content={
        <Typography id={contentId}>
          {intl.formatMessage(
            { id: contentId },
            { contactNumber: contactNumber },
          )}
        </Typography>
      }
    />
  );
};

ForgotPasswordInfoAlert.propTypes = {
  contentId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default ForgotPasswordInfoAlert;
